import { fieldIsValid } from "../../../../../lib/helper";
import { DatePicker } from "../../../../../../common/Atoms/DatePicker";
import { FormDescription } from "../../../../../../common/Atoms/FormDescription";

import { IFieldProps } from "./fieldProps";

export function EarliestInterestDate({
  policyFormData,
  invalids,
  handleChange,
}: IFieldProps) {
  return (
    <div className={ `w-full` }>
      <DatePicker
        className={ `min-w-full` }
        label={ `Earliest interest date` }
        onChange={ handleChange }
        name={ `earliest_interest_date_string` }
        invalid={ fieldIsValid(`earliest_interest_date_string`, invalids) }
        value={
          policyFormData.earliest_interest_date_string === null
            ? ``
            : policyFormData.earliest_interest_date_string
        }
      />
      <FormDescription>
        { `The earliest date that interest can be calculated from. This is used for prorata calculations.` }
      </FormDescription>
    </div>
  );
}
